import { BrowserRouter as Router } from "react-router-dom";
import Navbar from './components/header/navbar';
import AppRoutes from './components/app-routes';
import "./App.css";
import "./styles/base.css"
import CustomCursor from "./components/custom-cursor";
import Footer from "./components/footer/footer";
// import CustomCursor from './components/custom-cursor';
function App() {
  return (

 <div className=" h-screen bg-gray-100 cursor-none">
  <CustomCursor />
{/* <CustomCursor /> */}
<Router>
<Navbar style={{ backgroundColor: "rgba(188, 226, 245, 1)", height: "200px" }}/>
<AppRoutes />
 <Footer />
</Router>
</div>

  );
}

export default App;